import { render, staticRenderFns } from "./Userbar.vue?vue&type=template&id=244442f4&scoped=true&"
import script from "./Userbar.vue?vue&type=script&lang=js&"
export * from "./Userbar.vue?vue&type=script&lang=js&"
import style0 from "./Userbar.vue?vue&type=style&index=0&id=244442f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244442f4",
  null
  
)

export default component.exports